/* sb-dc-stagefit.js - keeps the Konva stage the same size as its container.

   The editor measures .canvas-viewport once, when it mounts, and never again.
   window resize, the Fit button, __dcRefit() and __dcFitAll() all leave the
   stage exactly as it was. When that one measurement comes back empty - which
   it does intermittently, roughly one boot in three on a phone-sized window -
   the stage falls back to 800x500 and sits clipped inside a 415px column, so
   the customer sees a slice of their banner and cannot scroll to the rest.

   Nothing in the app corrects it, but the stage object itself will take a new
   size: setting width/height and redrawing, then pressing Fit, brings the
   board back correctly. So this watches for the stage and its container
   disagreeing and fixes it.

   It keeps watching rather than running once, because the same disagreement
   appears whenever the container changes height - the panel sheet opening, or
   the address bar collapsing on iOS.

   Only the stage geometry is touched. Nothing here changes the design, the
   spec, or anything that reaches an order. */
(function () {
  var TOL = 2;
  var lastFix = 0;

  function stage() {
    var K = window.Konva;
    return (K && K.stages && K.stages.length) ? K.stages[0] : null;
  }

  function pressFit() {
    var buttons = document.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      if ((buttons[i].textContent || '').trim() === 'Fit') { buttons[i].click(); return true; }
    }
    return false;
  }

  function check() {
    var st = stage();
    var box = document.querySelector('.canvas-viewport');
    if (!st || !box) return;
    var rect = box.getBoundingClientRect();
    var w = Math.round(rect.width), h = Math.round(rect.height);
    if (w < 40 || h < 40) return;                 /* not laid out yet */
    if (Math.abs(st.width() - w) <= TOL && Math.abs(st.height() - h) <= TOL) return;

    /* Don't thrash if something else is fighting us. */
    var now = Date.now();
    if (now - lastFix < 700) return;
    lastFix = now;

    st.width(w);
    st.height(h);
    st.draw();
    /* Fit re-centres and re-zooms the board inside the corrected stage; on its
       own the stage would be the right size with the board off in a corner. */
    setTimeout(pressFit, 60);
    window.__dcStageFit = { to: w + 'x' + h, at: new Date().toISOString() };
  }

  var timer = setInterval(function () {
    try { check(); } catch (e) { /* never let this break the editor */ }
  }, 300);

  window.addEventListener('resize', function () { setTimeout(check, 120); });
  window.addEventListener('pagehide', function () { clearInterval(timer); });

  window.__dcStageState = function () {
    var st = stage();
    var box = document.querySelector('.canvas-viewport');
    return {
      stage: st ? st.width() + 'x' + st.height() : null,
      container: box ? Math.round(box.getBoundingClientRect().width) + 'x' + Math.round(box.getBoundingClientRect().height) : null,
      lastFix: window.__dcStageFit || null
    };
  };
})();
